<template>
  <div>
    <el-container>
      <el-main style="padding: 0; display: flex">
        <div style="width: 550px;">
          <span>通用扫描</span>
          <el-divider/>
          <el-form
              ref="form"
              v-loading="submitLoading"
              style="width: 550px"
              :rules="ruleValidate"
              :model="model"
              class="form"
              label-width="90px"
              @submit.native.prevent>
            <!--          <el-form-item label="生产工单" prop="orderNo">-->
            <!--            <el-input-->
            <!--                ref="orderNoInput"-->
            <!--                v-model="model.orderNo"-->
            <!--                placeholder="请扫生产工单号"-->
            <!--                size="mini"-->
            <!--                @keyup.enter.native.stop="orderNoScan"/>-->
            <!--          </el-form-item>-->
            <!--          <el-form-item label="工序" prop="operationNo">-->
            <!--            <el-select-->
            <!--                v-model="model.operationNo"-->
            <!--                placeholder="请选择工序"-->
            <!--                @change="processChange">-->
            <!--              <el-option-->
            <!--                  v-for="item in form.routingList"-->
            <!--                  :key="item.pkId"-->
            <!--                  :label="item.procedureName"-->
            <!--                  :value="item.operationNo"/>-->
            <!--            </el-select>-->
            <!--          </el-form-item>-->
            <el-form-item label="序列号" prop="snSerialNo">
              <el-input
                  ref="snSerialNoInput"
                  v-model="model.snSerialNo"
                  placeholder="请扫描序列号"
                  size="mini"
                  @keyup.enter.native.stop="snSerialNoChange"/>
            </el-form-item>
          </el-form>
          <span>扫描记录</span>
          <el-divider/>
          <el-table
              style="width: 550px"
              border
              stripe
              height="calc(50vh - 130px)"
              :data="confirmationRecord">
            <el-table-column type="index" align="center" label="#"/>
            <el-table-column prop="billNo" align="center" label="订单号"/>
            <el-table-column prop="sn" align="center" label="序列号"/>
            <el-table-column prop="station" align="center" label="工序"/>
            <!--          <el-table-column prop="materialName" align="center" label="创建人"/>-->
            <el-table-column prop="createTime" align="center" label="创建时间"/>
          </el-table>
        </div>
        <!-- 历史扫码记录 -->
        <scan-history-comp
            ref="scanHistoryComp"
            title="历史扫码记录"
            :storage-key-prefix="storageKey"
            :delete-auth-index="758"
        />
      </el-main>
    </el-container>
    <!-- 订单信息 -->
    <order-infor-comp ref="orderInforComp"/>
  </div>
</template>

<script>
  import ScanHistoryComp from "./ScanHistoryComp.vue";
  import OrderInforComp from "./OrderInforComp.vue";
  export default {
    name: "GeneralScan",
    components: {
      ScanHistoryComp,
      OrderInforComp,
    },
    data() {
      return {
        submitLoading: false,
        getDataLoading: false,
        complete: false,
        confirmationRecord: [],
        // localStorage key 前缀（动态传入，用于区分不同页面）
        storageKey: "GeneralScan",
        form: {
          routingList: [],
        },
        model: {
          orderNo: "",
          operationNo: "",
          snSerialNo: "",
        },
        ruleValidate: {
          orderNo: [{required: true, message: "请扫描工单号", trigger: "blur"}],
          operationNo: [{required: true, message: "请选择工序", trigger: "blur"}],
          snSerialNo: [{required: true, message: "请扫描序列号", trigger: "blur"}],
        },
      };
    },

    methods: {
      orderNoScan() {
        if (this.model.orderNo) {
          this.submitLoading = true;
          this.$http.get("basic", `sapProductionOrders/getByNo/${this.model.orderNo}`).then((res) => {
            if (res.success) {
              console.log(res.data);
              this.submitLoading = false;
              this.form = res.data;
            } else {
              this.submitLoading = false;
            }
          }).catch(() => {
            this.submitLoading = false;
          });
        }
      },
      processChange() {
        this.$refs.snSerialNoInput.focus();
      },
      snSerialNoChange() {
        // if (this.model.orderNo && this.model.operationNo && this.model.snSerialNo) {
        this.submitLoading = true;
        let params = {
          // billNo: this.model.orderNo,
          // station: this.model.operationNo,
          snSerialNo: this.model.snSerialNo,
        };
        this.$http.post("basic", "sapProductionOrders/confirmOrder", params).then((res) => {
          if (res.success) {
            // 保存条形码到历史记录
            if (this.$refs.scanHistoryComp) {
              this.$refs.scanHistoryComp.saveBarcode(this.model.snSerialNo);
            }
            if(this.$refs.orderInforComp) {
              this.$refs.orderInforComp.getData(res.data.billNo);
            }
            this.confirmationRecord = [res.data];
            this.submitLoading = false;
            this.model.snSerialNo="";
            this.$playScanSuccess();
          } else {
            this.$refs.snSerialNoInput.focus();
            this.model.snSerialNo="";
            this.submitLoading = false;
            this.$playScanFailure();
          }
        }).catch(() => {
          this.submitLoading = false;
        });
      },
    },
  };
</script>
<style scoped lang="scss">
::v-deep .el-container{
  height: 50vh;
}
</style>

